import React, { FunctionComponent, useEffect, useState, Fragment } from 'react';
import Logo from '../../../assets/img/logodeveloper-pequeño.png';
import faUserCircle2 from '../../../assets/img/icono.png';
import { Row, Col, Dropdown, Form, Image, Modal, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTerminal, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useHistory } from 'react-router-dom';
import SessionExpired from '../../Modals/sessionExpired';
import InactivityModal from '../../Modals/inactivityModal';
import Cookies from 'universal-cookie';
import SessionService from '../../../services/SessionsService';
import ReactGA from 'react-ga4';
import AddOrganizationModal from '../../Modals/addOrganizationModal';
import ObexRequestHandler from '../../../handlers/ObexRequestsHandler';
// import "./style.css"

import logo2 from "../../../assets/img/newAvapCloud/logo_Cloud@2x.png";
import logo1 from "../../../assets/img/AVAP_DeveloperPortal2.png"
import AddOrganizationSlots from '../../Modals/addOrganizationSlots';
import config from '../../../configs/appConfig.json'
interface HeaderProps {
  isDashboardBlue?: any; // Aquí especificas que 'sider' puede ser de cualquier tipo
}

const Header: FunctionComponent<HeaderProps> = ({ isDashboardBlue = false }) => {

  const history = useHistory();
  const [isLoggedIn, setLogged] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [inactivity, setInactivity] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [projects, setProjects] = useState([]);
  const [nombreOrganizacion, setNameOrg] = useState('');
  const [currentOrganizations, setCurrentOrganizations] = useState(0);
  const [maxOrganizations, setMaxOrganizations] = useState(0);
  const cookies = new Cookies();

  const [usersuscriptor, setusersuscriptor] = useState(true);
  const [developer, setDeveloper] = useState(false);
  const [client, setClient] = useState(false);

  const [addingOrg, setaddingOrg] = useState(false)


  const [showModalImg, setShowModalImg] = useState(false);


  const [selectedImage, setSelectedImage] = useState(null);
  const [disabledButtonSendImg, setDisabledButtonSendImg] = useState(false);
  const [errorMsg, setError] = useState('');


  const [fileName, setFilename] = useState('Select File')

  const placeAvatar = 'data:image/png;base64,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'

  const handleClose = () => setShowModalImg(false);

  const handleSubmit = async() => {
    // Aquí puedes enviar la imagen al servidor o realizar otras acciones necesarias
      // Restablece el estado después de enviar la imagen
    if (selectedImage) {

      setDisabledButtonSendImg(true);

      const safedstring = selectedImage.toString(); 
      const base64SafedString = btoa(safedstring);

      const payload = { image: base64SafedString };
      
      try{
      const result = await ObexRequestHandler.post('/update_avatar', payload);
      
      // debugger
      if(result.success && result.success==true){
        setSelectedImage(null);
        setShowModalImg(false);
        setDisabledButtonSendImg(false);

        const output = document.getElementById('AvatarImageHeader') as HTMLImageElement;
        //console.log(output);
        //console.log(base64SafedString)
        output.src = safedstring;

        //getPersonalInformation(); //re-render
      } else {
        setError('Image too big');
        setDisabledButtonSendImg(false)

        setTimeout(() => {
          setError('');
        }, 2000);


      }

    } catch {
      setError('Image too big');
      setDisabledButtonSendImg(false)
    }
      
    } else {
      console.log('No se ha seleccionado ningún archivo');
      setDisabledButtonSendImg(false)
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
      console.log(file);
      setFilename(file.name);
    }
  };

  const handleOrg = () => {
   
    console.log('RECUPERANDO PROYECTOS');
    SessionService.ORGANIZATIONS = null;
    SessionService.dispatchOrganizationChangedEvent();
    //await getProjects();
    setaddingOrg(!addingOrg);

  }


  const analyticsTags = [
    'G-MQZQJN7TQL',
    'G-98LF8608ZM',
    'G-KKCW4SZLW4',
    'G-EL6DCZWCM7',
    'G-5LKNTQFGD8',
    'G-11ZHMK4Y4Z',
    'G-PDYER55NCM'
  ];
  //ReactGA.initialize('UA-170480071-2');
  //analyticsTags.forEach(tag => {
  //  ReactGA.initialize(tag);
  //});
  
  const handleLogout = (e) => {
    e.preventDefault();
    e.stopPropagation();
    SessionService.logout();
    history.push('/login');

  }

  const getProjects = async () => {
    try {
      console.log("PROG")
      setProjects([]);
      console.log("PROG1")
      let projects = null;
      console.log("PROG2")
      if (SessionService.ORGANIZATIONS == null) {
        console.log('HACIENDO LLAMADA')
        projects = (await ObexRequestHandler.get('/organizations', {}, true)).data || [];
        SessionService.ORGANIZATIONS = projects
      }
      else {
        projects = SessionService.ORGANIZATIONS;
      }
      if (projects.length == 0) {
        setNameOrg('My Company');
        SessionService.ORGANIZATION_NAME = 'My Company';
        SessionService.ORGANIZATION = -1;
      } else {
        if (projects.result.length == 0) {
          setNameOrg('My Company');
          SessionService.ORGANIZATION_NAME = 'My Company';
          SessionService.ORGANIZATION = -1;
        }
      }
 
      setCurrentOrganizations(projects['result'].length);
      setMaxOrganizations(projects['max']);

      setProjects(projects['result']);

      if (projects['result'].length > 0) {
        if (SessionService.ORGANIZATION_NAME == null) {
          setNameOrg(projects['result'][0]['name']);
          SessionService.ORGANIZATION_NAME = projects['result'][0]['name'];
          SessionService.ORGANIZATION = projects['result'][0]['id'];
        } else {
          setNameOrg(SessionService.ORGANIZATION_NAME);
        }
      } else {
        SessionService.ORGANIZATION_NAME = 'Sin Organización';
        SessionService.ORGANIZATION = -1;
      }

    } catch (error) {
      console.error('ERROR FETCHING PROJECTS ', error);


    }

  }


  useEffect(() => {

if (isLoggedIn){
  window.location.replace('/marketplaceStore')
}

    if (config.url != 'https://avs-primary-pre.101obex.mooo.com') ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: 'Avap Cloud' })//pageview(window.location.pathname + window.location.search);

    const user = cookies.get('101Obex');
    if (user) {
      //console.log('User data')
      //console.log(user);
      setDeveloper(SessionService.Developer);
      setusersuscriptor(SessionService.User);
      setClient(SessionService.Client);
      if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
        SessionService.renewSession();
      }
      setLogged(true);
      getProjects();
      //console.log("header", isDashboardBlue);

    }
  }, [])

  // Como este componente siempre está presente ponemos aquí el listener del inactivityEvent para que lancé el modal
  document.addEventListener('inactivityEvent', (e) => {

    e.preventDefault();
    e.stopPropagation();
    setInactivity(true);
  }, false);

  document.addEventListener('organizationsChange', (e) => {

    e.preventDefault();
    e.stopPropagation();
    getProjects();

  }, false);

  //organizationsChange

  // Como este componente siempre está presente ponemos aquí el listener del sessionExpiredEvent para que lancé el modal
  document.addEventListener('sessionExpiredEvent', (e) => {

    if (sessionExpired) return;
    e.preventDefault();
    e.stopPropagation();
    setSessionExpired(true);
  }, false);

  const setName = (orga) => {

    setNameOrg(orga.name);
    SessionService.ORGANIZATION_NAME = orga.name;
    SessionService.ORGANIZATION = orga.id;
    history.push('/cloud_dashboard');
    return orga.name;
  }



  const renewSession = async (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      await SessionService.renewSession();
      setInactivity(false);
    } catch (error) {
      console.error(error);
    }
  }
  const handleModal = () => {

    setShowModal(!showModal);
    SessionService.ORGANIZATIONS = null;
    SessionService.dispatchOrganizationChangedEvent();
  };

  const on_Change = (event) => {
    const value = event.target.value;

    // this will return C:\fakepath\somefile.ext
    console.log(value);

    const files = event.target.files;

    //this will return an ARRAY of File object
    console.log(files);


    const input = event.target;

    const reader = new FileReader();
    reader.onload = function () {
      const dataURL = reader.result;
      const output = document.getElementById('output') as HTMLImageElement;
      //document.getElementById('output').setAttribute( 'src',dataURL);
      output.src = dataURL.toString();
      console.log(dataURL)
    };
    reader.readAsDataURL(input.files[files.length - 1]);

    //setImage(files[(files.length)-1].name);

    //setNoUpload(false);

  }

  return (
    <Fragment>
      <SessionExpired show={sessionExpired} handleHide={handleLogout} />
      <InactivityModal show={inactivity && !sessionExpired} renewSession={renewSession} closeSession={handleLogout} />
      {!isDashboardBlue && (
        <>
          <Row style={{ justifyContent: 'center', marginLeft:'0px' }} className={'py-0 fixed-top px-2 position-fixed'} id="header">

            <Row style={{ width: '100%' }}>

              {/* IM REMOVE THIS */}
              {/* <Col md={3} className={'pl-3 my-auto'}>
    <a href="/dashboard">
      <img className="logo" src={Logo}/>
    </a>
</Col> */}
              <div className={' my-auto'} style={{ width: "237px", display:'flex', justifyContent:'center' }}>
                <a href="/default">
                  <img className="logo" src={logo1} height={"30px"} style={{marginLeft:'8px'}}/>
                </a>
              </div>

              <Col className="my-auto">
                <Row className="menu-header justify-content-end align-items-center" style={{ width:'95.5%' }}>
                  <Col sm={1} style={{minWidth:'250px'}}><a className = {window.location.pathname === '/docs' ? 'link-2 fonsize14' : 'link link-header fonsize14'}  onClick={() => history.push('/docs')} style={{ textAlign: 'center' }}>AVAP Language Specifications</a></Col>
                  <Col sm={1} ><a className={window.location.pathname === '/wiki' ? 'link-2 fonsize14' : 'link link-header fonsize14'}  onClick={() => history.push('/wiki')} style={{ textAlign: 'center' }}>Docs</a></Col>
         {/*}         <Col sm={1} style={{minWidth:'120px'}}><a className={window.location.pathname === '/apis' ? 'link-2 fonsize14' : 'link link-header fonsize14'}  onClick={() => history.push('/apis')} style={{ textAlign: 'center' }}>API Products</a></Col> */}


                  {/*    <Col><a className="link link-header" onClick={() => history.push('/downloads')}style={{textAlign: "center"}}>Downloads & GitHub</a></Col>  */}


                  {/* IM REMOVE THIS */}
                  {/* <Col><a target="_blank" rel="noopener noreferrer" href="https://status.101obex.com/" className="link link-header" style={{ textAlign: 'center' }}>Status</a></Col> */}

                  {isLoggedIn ?
                    //     <Dropdown>
                    //     <Dropdown.Toggle className="button-support" >Community Support</Dropdown.Toggle>
                    //     <Dropdown.Menu>
                    //       <Dropdown.Item onClick={() => (history.push('https://101obexworkspace.slack.com/'))}>Technical Support</Dropdown.Item>
                    //
                    //     </Dropdown.Menu>{' '}
                    //   </Dropdown>
                    <Col style={{ minWidth:'180px' }} sm={1}><a target="_blank" rel="noopener noreferrer" href="https://speed-computing-1656.my.site.com/communities/s/" className="link link-header fonsize14" style={{ textAlign: 'center' }}>AVAP Communities</a></Col>
                    :
                    <Col sm={1} style={{ minWidth:'180px' }}> <a target="_blank" rel="noopener noreferrer" href="https://speed-computing-1656.my.site.com/communities/s/" className="link link-header fonsize14" style={{ textAlign: 'center' }}>AVAP Communities</a></Col>

                  }

                  <Col sm={2}><a className="link link-header fonsize14" onClick={() => history.push('/login')} style={{ textAlign: 'center' }}>
                    <div>
                     {/*} Sign In <span className='fonsize12'>→</span> */}
                     <button 
                    style={{ marginLeft:'-4px', padding:'0px', width:'190px', height:'30px' }}
                    className='custom-button-green textBold'
                    onClick={()=>{history.push('/login')}}
                >
                        Login to AVAP ID
                </button>
                    </div>
                  </a></Col>
                </Row>
              </Col>



              {isLoggedIn ?
              <span style={{paddingRight:'20px', paddingTop:'10px', cursor:'pointer'}}onClick={()=>{SessionService.eventEmitter.emit('panel', 'Bob');}}><FontAwesomeIcon icon={faTerminal}/></span>
                // <Col md={1} className="user text-right my-auto">
                //   <Dropdown className="mr-1">
                //     <Dropdown.Toggle className="link-user" id="obex-user-menu">{/*<FontAwesomeIcon icon={faUserCircle} size="2x"/>*/}<div style={{ height:'30px' }}><Image id='AvatarImageHeader' style={{ height:'30px' }} src={SessionService.imageContent}/></div></Dropdown.Toggle>
                //     <Dropdown.Menu>
                //       { usersuscriptor && <Dropdown.Item onClick={() => {
                //         history.push('/dashboard')}}><h5>Administrator Dashboard</h5></Dropdown.Item>}
                //       { developer && <Dropdown.Item onClick={() => {
                //         SessionService.ORGANIZATION_NAME = null;
                //         history.push('/devdashboard')}}>Developer Dashboard</Dropdown.Item>}
                //       { client && <Dropdown.Item onClick={() => {
                //         SessionService.ORGANIZATION_NAME = null;
                //         history.push('/clientdashboard')}}>Client Dashboard</Dropdown.Item>}
                //       <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                //     </Dropdown.Menu>{' '}
                //   </Dropdown>
                // </Col>
                
                :
                // <Col md={2} className="login text-right my-auto">
                //   <a style={{ height:'47px', width:'200px', marginRight:'-20px', paddingTop:'12px', fontSize:'16px' }} href="/login" className="link-login">Log into Developer Portal</a>
                // </Col>
                <></>
              }


              {/* <Col md={1}>
  <SelectLanguage/>
</Col>*/}


            </Row>
          </Row>
        </>
      )}

      {isDashboardBlue  && (
        <>
          <Row style={{ justifyContent: 'center', marginLeft:'0px' }} className={'py-0 fixed-top px-2'} id="header">

            <Row style={{ width: '100%' }}>

              {/* IM REMOVE THIS */}
              <div className={'pl-3 my-auto'} style={{ width: "320px" }}>
                <a href="/dashboard">
                  <img className="logo sizeAvapCloud" src={logo2} height={"30px"} />
                </a>
              </div>

              <div className="my-auto col mx-0 px-0">
                <div className="d-flex justify-content-between align-items-center">
                  <div className='d-flex align-items-center'>
                    {/*}
                  <div className="pr-5"><a className="link link-header fonsize14 px-0 mx-0" onClick={() => history.push('/docs/download/download_101cli')} style={{ textAlign: 'center', color: "#000" }}>Docs</a></div>
                  <div className="pr-5"><a className="link link-header fonsize14 px-0 mx-0" onClick={() => history.push('/wiki')} style={{ textAlign: 'center', color: "#000" }}>Wiki</a></div>
                  <div className="pr-5"><a className="link link-header fonsize14 px-0 mx-0" onClick={() => history.push('/apis/login/Accesos_EN')} style={{ textAlign: 'center', color: "#000" }}>APIs</a></div>
*/}

                  {/*    <Col><a className="link link-header" onClick={() => history.push('/downloads')}style={{textAlign: "center"}}>Downloads & GitHub</a></Col>  */}


                  {/* IM REMOVE THIS */}

                  
               {/*}   <div className="pr-5"><a target="_blank" rel="noopener noreferrer" href="https://status.101obex.com/" className="link link-header px-0 mx-0" style={{ color: "#000" }}>Status</a></div> */}


{/*}
                  {isLoggedIn ?
                    //     <Dropdown>
                    //     <Dropdown.Toggle className="button-support" >Community Support</Dropdown.Toggle>
                    //     <Dropdown.Menu>
                    //       <Dropdown.Item onClick={() => (history.push('https://101obexworkspace.slack.com/'))}>Technical Support</Dropdown.Item>
                    //
                    //     </Dropdown.Menu>{' '}
                    //   </Dropdown>
                    <div className="pr-5"><a target="_blank" rel="noopener noreferrer" href="https://101obexworkspace.slack.com/" className="link link-header fonsize14 px-0 mx-0" style={{ color: "#000" }}>Support</a></div>
                    :
                    <div className="pr-5"> <a target="_blank" rel="noopener noreferrer" href="https://101obexworkspace.slack.com/" className="link link-header fonsize14 px-0 mx-0" style={{ color: "#000" }}>Support</a></div>

                  }
                    */}
                  </div>

                  <div className='d-flex align-items-center'>
                    <div>
                      {isLoggedIn ?
                        <Dropdown className='my-auto pr-4'>
                          <Dropdown.Toggle className="organizations pl-0 ml-0 fonsize14 " id='fonto'>{nombreOrganizacion}</Dropdown.Toggle>
                          <Dropdown.Menu className='fonsize14'>

                            {projects.map(x => {

                              return (<Dropdown.Item key={x.id} onClick={() => { setName(x) }} className="fonsize14">{x.name}</Dropdown.Item>);

                            })}


                            {currentOrganizations < maxOrganizations ?
                              <Dropdown.Item onClick={() => { setShowModal(true) }}>Create Organization</Dropdown.Item>
                              :
                              <Dropdown.Item onClick={() => { setaddingOrg(true) }}>Create Organization</Dropdown.Item>

                            }

                          </Dropdown.Menu>{' '}
                        </Dropdown>

                        :
                        <span></span>

                      }


                    </div>

                    <div>

{/*}
                      {isLoggedIn ? (
                        <>
                          <div className='pr-4'><a className="link link-header fonsize14" onClick={() => history.push('/login')} style={{ textAlign: 'center', color: "#000" }}>
                            <div onClick={handleLogout}>
                              Sign out
                            </div>
                          </a></div>
                        </>
                      ) :
                        <>
                          <div ><a className="link link-header fonsize14" onClick={() => history.push('/login')} style={{ textAlign: 'center' }}>
                            <div>
                              Sign In <span className='fonsize12'>→</span>
                            </div>
                          </a></div>
                        </>
                      }

*/}



                    </div>

                    <div>
                      {isLoggedIn ?
                        <>
                          <div  className="user text-right my-auto pr-5">
                            <Dropdown className="mr-1">
                              <Dropdown.Toggle onClick={()=>{setShowModalImg(true)}} className="link-user" id="obex-user-menu"><div style={{ height: '30px', width:'30px', borderRadius:'50% !important' }}><Image id='AvatarImageHeader' style={{ height: '30px', borderRadius:'50%' }} src={SessionService.imageContent} /></div></Dropdown.Toggle>
                              {/*}
                              <Dropdown.Menu>
                                {usersuscriptor && <Dropdown.Item onClick={() => {
                                  history.push('/cloud_dashboard')
                                }}><h5>Administrator Dashboard</h5></Dropdown.Item>}
                                {developer && <Dropdown.Item onClick={() => {
                                  SessionService.ORGANIZATION_NAME = null;
                                  history.push('/devdashboard')
                                }}>Developer Dashboard</Dropdown.Item>}
                                {client && <Dropdown.Item onClick={() => {
                                  SessionService.ORGANIZATION_NAME = null;
                                  history.push('/clientdashboard')
                                }}>Client Dashboard</Dropdown.Item>}
                                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                              </Dropdown.Menu>{' '}
                              */}
                            </Dropdown>
                          </div>
                        </>
                        :
                        <>
                          <div  className="login text-right my-auto">
                            <a style={{ height: '47px', width: '200px', marginRight: '-20px', paddingTop: '12px', fontSize: '16px' }} href="/login" className="link-login">Log into Developer Portal</a>
                          </div>
                        </>
                      }

                    </div>

                  </div>






                </div>
              </div>





              {/* <Col md={1}>
  <SelectLanguage/>
</Col>*/}


            </Row>
          </Row>
        </>
      )}


<Modal style={{ marginTop:'7rem' }} show={showModalImg} onHide={handleClose} id="modalImg" dialogClassName="addons-dialog w-75 obex-dialog">
        <Modal.Header closeButton className="border-0 pb-0">
          <Col style={{ textAlign:'center' }}>
          <Modal.Title  className='fontSizeTitleCard textBold' style={{fontSize:'1.5rem', color:'black'}}>Select an image for your avatar</Modal.Title>
          </Col>
        </Modal.Header>
        <Modal.Body className=''>
          <Form >
            <Row>
              <Col style={{ marginLeft:'20px', marginRight:'20px', borderColor:'lightgray', borderStyle:'solid', borderWidth:'1px', borderRadius:'9px' }}>
            <Form.Group  controlId="formFile" className='m-0'>
              {/*<Form.Control className='btn  custom-button' style={{margin:'20px'}} type="file" accept=".jpg,.jpeg,.png" onChange=
              {handleFileChange} />*/}

              <label htmlFor="file-upload" className="btn custom-button-blue textBold" style={{ margin:'20px' }}>
        Select a new Image
              </label>
    
        <input id="file-upload" type="file" accept='image/*' className='btn custom-button input-field ' hidden 
        onChange={ 
          handleFileChange
        }
         />      <span className='fontSizeTitleCard ' style={{ color:'black', position:'absolute', marginTop:'23px' }}>{fileName}</span>
              {/* Mostrar la vista previa de la imagen seleccionada */}
            </Form.Group>
            </Col>
            </Row>
              <div style={{maxHeight:'300px', overflow:'hidden'}} className='d-flex justify-content-center align-items-center'>
                <img src={selectedImage == undefined ? placeAvatar : selectedImage} alt="Preview" style={{ maxHeight:'300px', aspectRatio:'auto ', paddingTop:'20px', maxWidth: '30%', marginTop: '40px', marginBottom:'40px' }} />
              </div>
            
          </Form>
          { errorMsg!='' && <Alert variant='danger'>{errorMsg}</Alert> }
          
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex justify-content-center w-100'>
            <button className="btn custom-button-blue textBold" onClick={handleSubmit} disabled={disabledButtonSendImg}>Save</button>

          </div>
        </Modal.Footer>
      </Modal>




{(addingOrg) && <AddOrganizationSlots shown={addingOrg} onCloseAction={handleOrg} onSuccess={handleOrg} MaxDBSize={1} ActualDBSize={0}/>}

      {showModal && <AddOrganizationModal show={showModal} handleClose={handleModal} />}


    </Fragment>
  );
}

export default Header;